/**
 * Toast service – allows any code (e.g. React Query hooks, API layer) to show toasts
 * without React context. The ToastProvider registers a handler on mount.
 */
type ToastHandler = (options: {
  type?: string;
  message: string;
  duration?: number;
}) => void;

const toast = {
  _handler: null as ToastHandler | null,

  setHandler(handler: ToastHandler | null) {
    this._handler = handler;
  },

  show(options) {
    const opts = typeof options === 'string' ? { message: options } : options;
    const { type = 'info', message, duration } = opts || {};
    if (this._handler) this._handler({ type, message, duration });
  },

  error(message, options?: { duration?: number }) {
    this.show({ type: 'error', message, duration: options?.duration });
  },

  success(message, options?: { duration?: number }) {
    this.show({ type: 'success', message, duration: options?.duration });
  },

  info(message, options?: { duration?: number }) {
    this.show({ type: 'info', message, duration: options?.duration });
  },
};

export default toast;
